module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_android_01-450-775b4500d470e07b6542fb949c84a032.png";